// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/swiper/css/swiper.css
// module id = 240
// module chunks = 0